angular.module('zc.masterApi')

.factory "MasterCampaignPolicySet", ($resource, $q, $stateParams, Api) ->
  MasterCampaignPolicySet =
    $resource Api.path("/api/master/projects/:projectId/campaign_policy_sets/:campaignPolicySetId"),
    {
      get:
        projectId: '@id'
    }, {
      query:
        method: 'GET'
        isArray: false # Rails returns object instead of array
      update:
        method: 'PATCH'
      destroy:
        method: 'DELETE'
    }

  service =
    all: (projectId) ->
      d = $q.defer()
      MasterCampaignPolicySet.query {projectId: projectId}, (res) ->
        if res.success
          d.resolve res.campaign_policy_sets
        else
          d.reject null
      d.promise

    destroy: (projectId, policySetId) ->
      d = $q.defer()
      MasterCampaignPolicySet.destroy {projectId: projectId, campaignPolicySetId: policySetId}, (res) ->
        if res.success
          d.resolve res
        else
          d.reject null
      d.promise


  service



// WEBPACK FOOTER //
// ./src/master_admin_modules/master_api/api/master_campaign_policy_sets.service.js.coffee